import React, {Suspense} from 'react'
import {createRoot} from 'react-dom/client'
import RouterWrapper from './components/RouterWrapper'
import {initNavigator} from './navigator'
import {addRouter, group, partOfLayout, routesList} from './routes'
import {detectLocaleChange} from './locale'

let isScanned = false

/**
 * Start rendering application
 *
 * @param targetContainer string
 */
function boot(targetContainer: string = 'root'): void {
  if (isScanned) return

  const root = createRoot(document.getElementById(targetContainer) as HTMLElement)

  detectLocaleChange()

  // setCurrentLocale()

  initNavigator()

  root.render(
    <React.StrictMode>
      <Suspense fallback={<>Loading ...</>}>
        <RouterWrapper />
      </Suspense>
    </React.StrictMode>
  )

  isScanned = true
}

const router = {
  list: routesList,
  add: addRouter,
  partOfLayout,
  group,
  boot,
}

export default router
